export default {
	'user-create': 'Kullanıcı oluşturma',
	'user-edit': 'Kullanıcı düzenle',
	'edit-account-status': 'Hesap durumunu düzenleme',
	'are-you-sure-to-deactivate-an-account': 'Bir hesabı devre dışı bırakacağınızdan emin misiniz',
	'are-you-sure-to-activate-an-account': 'Bir hesabı aktif edeceğinizden emin misiniz',
	'user-power': 'Kullanıcı yetkisi',
	'store-name': 'Mağaza adı',
	'power-type': 'Yetki türü',
	casher: 'Kasiyer',
	'executive-director': 'Mağaza müdürü',
	optional: 'İsteğe bağlı',
	'change-password': 'Şifre değiştirme',
	'password-has-been-modified-successfully': 'Şifre başarıyla değiştirildi',
	active: 'Aktif',
	stopped: 'Durdurulan',
	'user-info': 'Kullanıcı Bilgileri',
	'the-user-has-been-added-successfully': 'Kullanıcı başarıyla eklendi',
	'user-data-has-been-modified-successfully': 'Kullanıcı verileri başarıyla değiştirildi',
	viewer: 'İzleyici',
	'user-permissions-for': 'Kullanıcı izinleri',
	permissions: {
		'permission-type': 'İzin türü',
		allowed: 'İzin verildi',
		read: 'Okuma',
		'not-Allowed': 'İzin verilmiyor',
	},
	permissionTypes: {
		configs: 'Verileri depolayın',
		currencies: 'Para birimleri',
		users: 'Kullanıcılar',
		stores: 'Mağazalar',
		cashboxes: 'Kasiyerler',
		'account-statement': 'Hesap ekstresi',
		'cash-journal': 'Nakit günlüğü',
		'closed-cash-journal': 'Günlük nakit kapanış günü',
		'all-cash-journal': 'Her nakit günlüğü',
		'detailed-day': 'Bugünün özeti',
		'daily-table': 'Günlük program',
		'item-tree': 'Malzeme ağacı',
		'sale-invoice': 'Satış faturası',
		'buy-invoice': 'Satın alma faturası',
		'sale-refund-invoice': 'Satış iade faturası',
		'all-invoices': 'Tüm faturalar',
		'items-journal': 'Günlük makaleler',
		'all-item-journals': 'Tüm günlük malzemeleri',
		'item-statement': 'Özel durum açıklaması',
		'inventory-report': 'Malzeme envanteri',
		reports: 'Raporlar',
		'close-cash-journal': 'Kasa günlüğünü kapat',
		'invoice-discount': 'Faturayı kapat',
		'invoice-change-account': 'Faturalandırma hesabını değiştir',
		'invoice-card': 'Faturayı kartla öde',
		'invoice-internal': 'Faturayı dahili olarak ödeyin',
		'invoice-debt': 'Faturayı kredi kartıyla öde',
		'account-tree': 'Hesap planı',
		'invoice-entries-discount': 'Fatura Seviyesinde Borç',
	}
}